import PropTypes from "prop-types";

export default function Card({ children, padded, className, style }) {
  const cls = `rec-card${padded ? " rec-card-pad" : ""}${className ? ` ${className}` : ""}`;
  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node,
  padded: PropTypes.bool,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

Card.defaultProps = {
  children: null,
  padded: true,
  className: "",
  style: undefined,
};
